<template>
  <div
    id="detailsform"
    class="shadow-xl rounded-md mt-5 mb-5 border-2 border-blue-600"
  >
    <div
      class="flex flex-row items-center space-x-4 p-10 justify-start flex-wrap"
    >
      <div id="changepass">
        <div class="avatar">
          <div class="mb-3 w-24 h-24 mask">
            <img src="@/assets/password.png" alt="user-profile image" />
          </div>
        </div>
      </div>
      <div id="confirmpass" class="flex-1">
        <div class="form-control w-full">
          <label class="label">
            <span class="label-text">Password</span>
          </label>
          <input
            v-model="password"
            type="text"
            placeholder="Password"
            class="input input-bordered"
          />
        </div>
        <div class="form-control w-full">
          <label class="label">
            <span class="label-text">Confirm Password</span>
          </label>
          <input
            v-model="confirmPassword"
            type="text"
            placeholder="Confirm Password"
            class="input input-bordered"
          />
          <label class="label"
            ><span class="label-text-alt"
              >After clicking submit you will be redirected to home page</span
            ></label
          >
        </div>

        <div class="form-control mt-5 ml-36 w-min">
          <button
            @click="updatePassword"
            type="submit"
            class="btn btn-info hover:bg-blue-500"
          >
            <span v-if="status">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clip-rule="evenodd"
                />
              </svg>
            </span>
            <span v-else>Submit</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { useRouter } from "vue-router";
export default {
  name: "ChangePassword",
  data() {
    return {
      status: false,
      router: useRouter(),
      password: null,
      confirmPassword: null,
    };
  },
  methods: {
    updatePassword() {
      if (!this.password && !this.confirmPassword) {
        confirm("Enter a details to update password");
      } else {
        const data = JSON.stringify({
          Reg_id: sessionStorage.getItem("id"),
          Password: this.confirmPassword,
        });
        this.status = !this.status;
        // console.log(data);
        axios
          .post(
            `http://sitraonline.org.in/employementhubapi/index.php/api/updatePassword`,
            data
          )
          .then((res) => {
            // console.log(res)
            if (res.status == 200) {
              this.status = true;
              setTimeout(
                () =>
                  this.router.push({
                    name: "Home",
                  }),
                1000
              );
            }
          })
          .catch((err) => console.log(err));
      }
    },
  },
};
</script>

<style></style>
